import type { IAftermarketCampaign } from '@/service/vpc/types/IAftermarketCampaign';

import { PERFORMED_CAMPAIGN_STATUSES } from '@/service/vpc/types/IInstallableCampaign';

export const showWebInstallButton = (campaign: IAftermarketCampaign): boolean => {
  const campaignType = campaign.aftermarketCampaignType;
  const status = campaign.installableCampaign?.status;
  return campaignType?.indexOf('Installation') >= 0 && !PERFORMED_CAMPAIGN_STATUSES.has(status ?? '');
};
